import PropTypes from 'prop-types'
import styled from 'styled-components'

/* FICPageSectionBlock */

export const FICPageSectionBlock = styled.div.attrs({
  className: 'fic-page-section-block'
})`
  text-align: ${props => props.align};
  float: ${props => props.align === 'center' ? 'none' : props.align};
  display: inline-block;
  margin-top: 8px;
  vertical-align: middle;
  flex: ${props => props.flex};
  a.btn-flat + a.btn-flat {
    margin-left: 8px;
  }
`

FICPageSectionBlock.propTypes = {
  style: PropTypes.object,
  align: PropTypes.oneOf(['center', 'left', 'right']),
  flex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

FICPageSectionBlock.defaultProps = {
  style: {},
  align: 'center',
  flex: undefined
}

/* FICPageSection */

const FICPageSection = styled.div.attrs({
  className: 'fic-page-section'
})`
  text-align: ${props => props.align};
  float: ${props => props.align === 'center' ? 'none' : props.align};
  flex: ${props => props.fillPage ? 1 : undefined};
  align-items: ${props => props.alignChildren};
  overflow-y: ${props => props.fillPage ? 'hidden' : undefined};
  margin-top:  ${props => props.spaced ? '15px' : 0};
  margin-bottom:  ${props => props.spacedBottom ? '15px' : 0};
  display: ${props => props.flexChildren ? 'inline-flex' : 'inline-block'};
  width: 100%;
  ${FICPageSectionBlock} + ${FICPageSectionBlock}{
    margin-left: 8px;
  }
  a.btn-flat + a.btn-flat {
    margin-left: 8px;
  }
`

export default FICPageSection

FICPageSection.propTypes = {
  style: PropTypes.object,
  align: PropTypes.oneOf(['center', 'left', 'right']),
  flexChildren: PropTypes.bool,
  alignChildren: PropTypes.string,
  fillPage: PropTypes.bool,
  scrollable: PropTypes.bool,
  spaced: PropTypes.bool,
  spacedBottom: PropTypes.bool
}

FICPageSection.defaultProps = {
  style: {},
  align: 'center',
  flexChildren: false,
  fillPage: false,
  scrollable: undefined
}

/* FICPageSectionSubtitle */

export const FICPageSectionSubtitle = styled(FICPageSection)`
  margin-top: 0;
`

/* FICPageSectionBlockText */

export const FICPageSectionBlockText = styled.span`
  font-size: 13px;
  line-height: 30px;
`



// WEBPACK FOOTER //
// ./src/common/layout/js/FICPageSection.js